import gettext from 'utils/gettext';
import clientConfig from 'utils/client-config-ex';
import Backbone from 'backbone';
import $ from 'jquery';

$.ajaxSetup({
  dataFilter: function(data, type) {
    return type === 'json' && !data ? '{}' : data;
  }
});

// Load translations before controller because controller may import file with gettext.
Promise.all([gettext.i18nInitD.finally(() => {}), clientConfig.loadD.finally(() => {})])
  .then(() => import('controllers/controller'))
  .then(({ Controller }) => {
    Backbone.controller = new Controller();
    Backbone.history.start();
  });